import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";
import { variantProp, getTokensPropType, useCopy, copyPropTypes, a11yProps } from '../utils';
import { useThemeTokens } from '../ThemeProvider';
import IconButton from '../IconButton';
import dictionary from './dictionary';
import { jsx as _jsx } from "react/jsx-runtime";

const selectContainerStyles = _ref => {
  let {
    offset
  } = _ref;
  return {
    marginTop: offset ? -offset : 0
  };
};
/**
 * Button within a Tabs component showing users that content is available to the left or
 * right, scrolling a screen's worth of content left or right when pressed.
 *
 * This is rendered automatically by `Tabs` and isn't intended be used directly.
 *
 * @TODO when IconButton is complete and stable revisit this and update interaction state styles.
 */


const HorizontalScrollButton = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    direction = 'next',
    icon,
    offset,
    onPress,
    variant,
    tokens,
    copy
  } = _ref2;
  const themeTokens = useThemeTokens('HorizontalScrollButton', tokens, variant);
  const getCopy = useCopy({
    dictionary,
    copy
  });
  const label = direction === 'previous' ? getCopy('previousText') : getCopy('nextText');
  return /*#__PURE__*/_jsx(View, {
    style: [staticStyles.absolute, staticStyles[direction], selectContainerStyles({
      offset
    })],
    children: /*#__PURE__*/_jsx(IconButton, {
      accessibilityLabel: label,
      icon: icon,
      onPress: onPress,
      ref: ref,
      tokens: themeTokens,
      variant: variant,
      ...a11yProps.nonFocusableProps
    })
  });
});
HorizontalScrollButton.displayName = 'HorizontalScrollButton';
const staticStyles = StyleSheet.create({
  absolute: {
    position: 'absolute'
  },
  previous: {
    left: 0
  },
  next: {
    right: 0
  }
});
HorizontalScrollButton.propTypes = {
  tokens: getTokensPropType('HorizontalScrollButton'),
  variant: variantProp.propType,
  copy: copyPropTypes,
  direction: PropTypes.oneOf(['previous', 'next']),
  offset: PropTypes.number,
  icon: PropTypes.elementType,
  onPress: PropTypes.func.isRequired
};
export default HorizontalScrollButton;